import React, { PropsWithChildren, ReactNode } from "react";

import { Label, Paragraph } from "@fronterahealth/frontera-ui-components";

interface NoDataCardProps extends PropsWithChildren {
  title: string;
  description?: ReactNode;
}

export const NoDataCard: React.FC<NoDataCardProps> = ({ title, description, children }) => {
  return (
    <div className="border border-border-medium rounded-md text-center bg-bg-default p-4 gap-8 mb-2">
      <div>
        <Label size="medium" displayType="loud" colorType="secondary">
          {title}
        </Label>
        <Paragraph size="small" displayType="normal" colorType="tertiary">
          {description}
        </Paragraph>
      </div>
      {children}
    </div>
  );
};
